import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/coaching/')({
  beforeLoad: () => {
    throw redirect({
      to: '/coaching/notes',
    });
  },
});
